import React, { useMemo } from 'react';

import sortBy from 'lodash/sortBy';
import PropTypes from 'prop-types';

import Context from './BreadCrumbContext';

const BreadCrumbsProvider = ({ children }) => {
    const [items, setItems] = React.useState([]);

    const addItem = React.useCallback((url, title) => {
        setItems((prevItems) => {
            const items = prevItems.filter((i) => i.url !== url);

            return sortBy([...items, { url, title }], 'url');
        });
    }, [setItems]);

    const removeItem = React.useCallback((url) => {
        setItems((prevItems) => prevItems.filter((i) => i.url !== url));
    }, [setItems]);

    const value = useMemo(() => ({
        items, addItem, removeItem, setItems,
    }), [items, addItem, removeItem, setItems]);

    return (
        <Context.Provider value={value}>
            { children }
        </Context.Provider>
    );
};

BreadCrumbsProvider.propTypes = {
    children: PropTypes.node,
};

export default BreadCrumbsProvider;
